var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.instagram.com/covid19visualproject/","target":"_blank"}},[_c('InstagramIcon',{staticClass:"icon"}),_vm._v(" "),_c('span',[_vm._v("contact us")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }